<template>
	<div class="card-body">
		<div v-if="carDescription">
			<div v-html="parseAdDescriptionCreoleSyntaxToHtml(carDescription)"></div>
		</div>
		<p v-if="deliveryPeriod > 0">
			Unverbindliche Lieferzeit ab Bestellung:
			{{ getDeliveryMonth(deliveryPeriod) }}.
		</p>
		<p v-if="deliveryDate > currentDate">
			Unverbindliches Lieferdatum: {{ formatDate(deliveryDate) }}.
		</p>
		<a
			class="font-12 float-end display-inline text-white"
			target="_blank"
			:href="
				'https://mobile.dispo24.de:8031/v1/pdf/create-qrcode-to-detail-page/internalNumber/' +
				carInternalNumber
			"
			>QR-Code PDF
		</a>
	</div>
</template>

<script>
export default {
	name: 'DetailsDescription',
	props: {
		carInternalNumber: String,
		carDescription: String,
		deliveryDate: {
			type: String,
			required: false,
			default: '',
		},
		deliveryPeriod: {
			type: Number,
			required: false,
			default: 0,
		},
	},
	computed: {
		currentDate() {
			return new Date().toISOString().slice(0, 10)
		},
	},
	methods: {
		parseAdDescriptionCreoleSyntaxToHtml(input) {
			const CREOLE_BOLD = /\*\*([a-z A-Z0-9\-&ßäöü]+)\*\*/g
			const CREOLE_LINE = /[-]{4}/g
			const CREOLE_LINEBREAK = /\\\\/g

			let out = input.replace(CREOLE_BOLD, (match, capture) => {
				return '<b>' + capture + '</b>'
			})

			out = out.replace(CREOLE_LINEBREAK, '<br>')
			out = out.replace(CREOLE_LINE, '<hr/>')

			return out
		},
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
